module.exports = __webpack_public_path__ + "media/packs/images/partners/happy-paw-logp-6b4ab5316aab6d5bd6c0bd10231eef1e.jpg";